import React from 'react';
import { List } from 'antd';
import Opinion from './Opinion';
import type { Mention } from './Opinion';

interface OpinionsListProps {
  mentions: Mention[];
}

const OpinionsList = function ({ mentions }: OpinionsListProps) {
  return (
    <List
      itemLayout="horizontal"
      dataSource={mentions}
      renderItem={(mention) => (
        <Opinion mention={mention} />
      )}
    />
  );
};

export default OpinionsList;
